<template>
  <!--右侧工作区-->
  <div>
    <div class="bannerImg"></div>
    <div class="lable">请输入多个热点关键词</div>

    <el-row>
      <el-autocomplete v-model="keyword" :fetch-suggestions="querySearchAsync" class="input" placeholder=""
        @select="handleSelect">
        <template slot-scope="{ item }">
          <div class="tipTitle" v-html="item.title"></div>

        </template>
      </el-autocomplete>

    </el-row>
    <el-row v-if="isVip">
      <div style="width:500px;margin:auto">
        <el-col :span='24' class="t_l">
          <div class="lable">推荐话题 <a href="javascript:void(0)" @click="addReferIndex">
              <div class="refreshBtn"></div>
            </a></div>

        </el-col>
        <div style="clear:both;height:10px;"></div>
        <template v-for="(item, index) in referList">
          <template v-if="index < referIndex * 6 && index >= (referIndex - 1) * 6">
            <div :key="index" class="tag">
              <el-link type="primary" :key="index" :underline="false"
                @click="genNetHotArticle(item.hotArticleId, item.hotTitle)">
                <el-tag>{{ item.hotTitle }}</el-tag>
              </el-link>
            </div>
          </template>
        </template>
      </div>
    </el-row>
    <el-row>
      <el-row style="clear:both;min-height:20px;text-align:left">
      </el-row>
      <el-button type="primary" @click="genArticleByKeyWord">开始写作</el-button>
    </el-row>

  </div>
</template>

<script>

import * as appJs from '../../assets/js/app'

export default {
  name: 'title_',
  data: function () {
    return {
      keyMap: {},
      keyword: '',
      referIndex: 1,
      referList: [],

      articleId: '',
      isVip: false

    }
  },
  methods: {

    addReferIndex () {
      this.referIndex++
      console.log(this.referIndex + '------' + this.referList.length)
      if (((this.referIndex - 1) * 6) >= this.referList.length) {
        this.referIndex = 1
      }
    },
    // 生产热点文章
    genNetHotArticle (hotArticleId, hotTitle) { // 使用热点写作
      let _this = this
      this.keyword = hotTitle
      this.axios.postWithLoading('/webApi/v3/robot/writingByNetHotIds', { 'newsIds': hotArticleId, 'hotTitle': hotTitle }).then(resp => {
        this.loading = false
        if (!resp.data.autoNewsId) {
          this.$message('写作未成功，换个词试试')
          return
        }
        _this.goDetail(resp.data.autoNewsId)
      })
    },
    // 跳转到详情页
    goDetail (articleId) {
      if (articleId) {
        this.$router.push({ path: '/newsEdit', query: { articleId: articleId, 'from': 'title' } })
      } else {
        _this.$message.error('写作失败，请换个词试试');
      }
    },
    // 命题写作
    genArticleByKeyWord (newsIds) {
      // Loading.startLoading('弈写正在努力写作中，请稍等...')

      let _this = this
      this.axios.postWithLoading('/webApi/v3/robot/writing-by-keyword', { 'sentence': _this.keyword, 'belongIds': newsIds }).then((response) => {
        if (response.data.autoNewsId) {
          _this.goDetail(response.data.autoNewsId)
        } else {
          _this.$message.error('写作失败，请换个词试试');
        }
      })
    },
    getHotPoints () { // 获取系统热点
      let _this = this
      this.axios.post('/webApi/v3/hot/refer-list-noRepeat').then((response) => {
        _this.referList = response.data.rows
      })
    },
    // 搜索关键词
    querySearchAsync (key, cb) {
      if (this.isVip) {
        let result = []
        if (!key) {
          cb(result)
          return
        }
        let tempKey = key.replace(/\s*/g, '')
        if (this.keyMap[tempKey]) {
          cb(this.keyMap[tempKey])
          return
        }

        let _this = this
        this.axios.post('/webApi/v3/hot/hot-tips-list?size=5&keyword=' + key, { '$noLoading': true }).then((response) => {
          response.data.forEach(e => {
            result.push({ 'value': _this.keyword, 'title': e.h_title || e.title, 'extValue': e.heightLightWordsStr, 'newsIds': e.newsIds })
          })
          cb(result)
          _this.keyMap[tempKey] = result
        })
      } else {
        cb(null)
      }
    },
    // 选择关键词
    handleSelect (val) {
      this.genArticleByKeyWord(val.newsIds)
    }

  },
  components: {

  },
  mounted () {
    this.getHotPoints()
    appJs.isVip().then(() => { this.isVip = true })
  },
  watch: {

  }
}
</script>
<style lang="less" scoped>
.bannerImg {
  background-image: url('../../assets/imgs/titleBanner.png');
}
</style>



// WEBPACK FOOTER //
// src/components/write/title.vue